<script setup lang="ts">
import Button                         from "@ViewCommonComponents/Button.vue";
import { useForm }                    from "@inertiajs/vue3";
import { inject }                     from "vue";
import type { TypeDeliveryStepsData } from "@ViewPages/Main/Components/commonTypes";
import { submit }                     from "@TsUtils/reactiveForm";

const props = inject<TypeDeliveryStepsData>('delivery_steps_data')

const form = useForm({
    firstname: null,
    telephone: null,
    step: null,
});

const labelClasses = [
        'peer-focus:font-medium absolute',
        'text-sm xl:text-lg text-custom-gray-500',
        'duration-300 transform -translate-y-6 scale-75',
        'top-1 left-3 -z-10 origin-[0] peer-focus:start-0',
        'peer-focus:text-blue-400 peer-placeholder-shown:scale-100',
        'peer-placeholder-shown:translate-y-0 peer-focus:scale-75',
        'peer-focus:-translate-y-6',
    ].join(' '),
    inputClasses = [
        'block py-3.5 px-3 xl:py-7 w-full text-sm xl:text-lg text-gray-900',
        'bg-transparent border-0 border-b-2 border-blue-900',
        'appearance-none focus:outline-none focus:ring-0',
        'focus:border-blue-400 peer',
    ].join(' ');
</script>

<template>
    <form @submit.prevent="submit($event, form, $event.target as HTMLElement, 'main.save-delivery-steps-request')"
          class="delivery-steps__form needs-validation
                flex max-md:flex-col md:justify-between md:flex-wrap xl:flex-nowrap
                max-md:gap-y-3.5 md:gap-x-6 md:gap-y-4"
          method="POST" novalidate>

        <div class="relative z-0 w-full md:max-w-45% lg:max-w-30% xl:max-w-32% group mb-3">
            <input type="text" id="floating-firstname" v-model="form.firstname"
                   :class="inputClasses"
                   minlength="3" maxlength="100"
                   placeholder=" " required/>

            <label for="floating-firstname" :class="labelClasses">
                {{ __('header_firstname') }}
            </label>

            <div class="_error mt-2 text-sm xl:text-lg text-red-600">
                {{ __('header_error_firstname') }}
            </div>

            <div class="mt-2 text-sm xl:text-lg text-red-600" v-if="form.errors.firstname">
                {{ form.errors.firstname }}
            </div>
        </div>

        <div class="relative z-0 w-full md:max-w-45% lg:max-w-30% xl:max-w-32% group mb-3">
            <input type="tel" id="floating-telephone" v-model="form.telephone"
                   :class="inputClasses"
                   pattern="(^((\+?\d{2,}\s?)|(.*))\(?\d{3,}\)?\s?\d{3,}-?\d{2,}-?\d{2,}$)"
                   minlength="10" maxlength="32"
                   placeholder=" " required/>

            <label for="floating-telephone" :class="labelClasses">
                {{ __('header_telephone') }}
            </label>

            <div class="_error mt-2 text-sm xl:text-lg text-red-600">
                {{ __('header_error_telephone') }}
            </div>

            <div class="mt-2 text-sm xl:text-lg text-red-600" v-if="form.errors.telephone">
                {{ form.errors.telephone }}
            </div>
        </div>

        <div class="relative z-0 w-full md:max-w-45% lg:max-w-30% xl:max-w-32% group mb-3">
            <label for="steps-list" :class="labelClasses">
                {{ __('delivery_choose_step') }}
            </label>

            <select v-model="form.step"
                    required
                    id="steps-list"
                    :class="inputClasses">

                <option selected value="">
                    {{ __('delivery_choose_step') }}
                </option>

                <template v-for="(data, index) in props?.delivery_steps_data" :key="index">
                    <option :value="'Stage: ' + (+index + 1) + ' - ' + data.title">
                        {{ (+index + 1) + ' - ' + data.title }}
                    </option>
                </template>
            </select>

            <div class="_error mt-2 text-sm xl:text-lg text-red-600">
                {{ __('delivery_error_step') }}
            </div>

            <div class="mt-2 text-sm xl:text-lg text-red-600" v-if="form.errors.step">
                {{ form.errors.step }}
            </div>
        </div>

        <Button type="submit" :disabled="form.processing"
                classes="inline-flex xl:shrink-0 px-12 self-start py-7">
            {{ __('send_request') }}
        </Button>
    </form>
</template>

<style scoped>

</style>
